import { AxiosResponse } from 'axios';

type ResponseData<T> = {
  code: number;
  message: string;
  data: T;
};

export default class HttpResponseError extends Error {
  /** 响应体 */
  response: AxiosResponse;

  /** 状态码 */
  code: number;

  /** 数据 */
  data: unknown;

  /** 信息 */
  message: string;

  constructor(response: AxiosResponse<ResponseData<unknown>>) {
    super();

    this.name = 'HttpResponseError';
    this.response = response;

    this.code = response.data.code;
    this.data = response.data.data;
    this.message = response.data.message;
  }
}
